export default __webpack_public_path__ + "static/assignee-do-7d0eca1d277fd36f39fd93d95ef754f0.png";